export default "__VITE_ASSET__COC3duEC__"